import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const MarketingClaimRoutes = defineRoute({
    record: {
        route: {
            path: "/marketing-claim",
            component: () => loadView(import("./MarketingClaimTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/marketing-claim/detail/:id",
            component: () => loadView(import("./MarketingClaimDetail.vue")),
        },
        build(id: string) {
            return `/marketing-claim/detail/${id}`;
        },
    },
});
